/**
 * Sticky Add to Cart on PDPs.
 *
 * Desktop / tablet (≥741px): title | Recharge options + ATC
 * Mobile (≤740px): product title + ATC side by side
 */
(function () {
  const CONFIG = {
    widgetSelector: 'recharge-subscription-widget',
    buttonSelector: '.product-info__add-to-cart[data-add-to-cart]',
    titleSelector: '.product-info__title',
    observeSelector: '.product-info__purchase',
    headerSelector: '.header, header.header, #shopify-section-header .header',
    announcementSelector: '.announcement-bar--always, .announcement-bar[data-sticky="true"]',
    wrapperId: 'sticky-atc',
    shadowStyleId: 'sticky-atc-recharge-style',
    waitTimeoutMs: 12000,
    waitIntervalMs: 200
  };

  const CHEVRON_SVG =
    '<svg class="sticky-atc__plan-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  const STICKY_WIDGET_CSS =
    ':host{display:block!important;width:auto!important;}' +
    '.rc-widget__root,[part~="rc-widget__root"]{display:block!important;width:auto!important;}' +
    '.rc-content-wrap,[part~="rc-content-wrap"]{' +
    'display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;' +
    'align-items:stretch!important;gap:8px!important;width:max-content!important;max-width:none!important;' +
    '}' +
    '.rc-purchase-option,[part~="rc-purchase-option"]{' +
    'display:flex!important;flex-direction:column!important;align-items:stretch!important;justify-content:center!important;' +
    'width:100%!important;height:auto!important;min-height:56px!important;max-height:none!important;box-sizing:border-box!important;' +
    '}' +
    '.rc-purchase-option__subscription,[part~="rc-purchase-option__subscription"]{' +
    'display:flex!important;flex-direction:column!important;flex:0 0 auto!important;align-self:stretch!important;' +
    'min-width:max-content!important;width:auto!important;max-width:none!important;' +
    'height:auto!important;min-height:56px!important;max-height:none!important;box-sizing:border-box!important;' +
    '}' +
    '.rc-purchase-option__onetime,[part~="rc-purchase-option__onetime"]{' +
    'display:flex!important;flex-direction:column!important;flex:0 0 auto!important;align-self:stretch!important;' +
    'min-width:max-content!important;width:auto!important;max-width:none!important;' +
    'height:56px!important;min-height:56px!important;max-height:56px!important;box-sizing:border-box!important;' +
    '}' +
    '.rc-purchase-option__onetime.rc-purchase-option,' +
    '[part~="rc-purchase-option__onetime"][part~="rc-purchase-option"]{' +
    'height:56px!important;min-height:56px!important;max-height:56px!important;' +
    '}' +
    '.rc-purchase-option__label,[part~="rc-purchase-option__label"]{' +
    'display:flex!important;flex-direction:row!important;align-items:center!important;' +
    'justify-content:normal!important;width:100%!important;' +
    '}' +
    '.rc-purchase-option__label,.rc-purchase-option__sub-container,.rc-purchase-option__prices,' +
    '[part~="rc-purchase-option__label"],[part~="rc-purchase-option__sub-container"],[part~="rc-purchase-option__prices"]{' +
    'white-space:nowrap!important;' +
    '}' +
    '.rc-benefits__list,.rc-benefits,.rc-learn-more,' +
    '[part~="rc-benefits__list"],[part~="rc-benefits"],[part~="rc-learn-more"]{display:none!important;}' +
    '@media (max-width:740px){' +
    '.rc-content-wrap,[part~="rc-content-wrap"]{' +
    'flex-direction:column!important;width:100%!important;max-width:none!important;' +
    '}' +
    '.rc-purchase-option__onetime,.rc-purchase-option__subscription,' +
    '[part~="rc-purchase-option__onetime"],[part~="rc-purchase-option__subscription"],' +
    '.rc-purchase-option,[part~="rc-purchase-option"]{' +
    'width:100%!important;min-width:0!important;max-width:none!important;' +
    '}' +
    '.rc-purchase-option:not(:last-child),' +
    '[part~="rc-purchase-option"]:not(:last-child){' +
    'margin-bottom:0!important;' +
    '}' +
    '}';

  function isMobileSticky() {
    return window.matchMedia('(max-width: 740px)').matches;
  }

  function createPlaceholder(id) {
    const el = document.createElement('div');
    el.className = 'sticky-atc__placeholder';
    el.id = id;
    el.setAttribute('aria-hidden', 'true');
    return el;
  }

  function setPlaceholderSize(placeholder, source) {
    if (!placeholder || !source) return;
    const rect = source.getBoundingClientRect();
    placeholder.style.height = Math.max(rect.height, 0) + 'px';
    placeholder.classList.add('is-active');
  }

  function clearPlaceholder(placeholder) {
    if (!placeholder) return;
    placeholder.style.height = '';
    placeholder.style.width = '';
    placeholder.classList.remove('is-active');
  }

  function getProductTitle() {
    const titleEl = document.querySelector(CONFIG.titleSelector);
    if (titleEl && titleEl.textContent.trim()) {
      return titleEl.textContent.trim();
    }
    const meta = document.querySelector('meta[property="og:title"]');
    if (meta && meta.content) return meta.content.trim();
    return document.title.split('|')[0].trim();
  }

  function isInsideSticky(el) {
    return !!(el && el.closest && el.closest('#' + CONFIG.wrapperId));
  }

  function updateStickyTop(wrapper) {
    let top = 0;
    const announcement = document.querySelector(CONFIG.announcementSelector);
    const header = document.querySelector(CONFIG.headerSelector);

    if (announcement) {
      const aRect = announcement.getBoundingClientRect();
      const aStyle = window.getComputedStyle(announcement);
      if (aStyle.position === 'fixed' || aStyle.position === 'sticky') {
        top = Math.max(top, aRect.bottom);
      }
    }

    if (header) {
      const hRect = header.getBoundingClientRect();
      const hStyle = window.getComputedStyle(header);
      if (
        hStyle.position === 'fixed' ||
        hStyle.position === 'sticky' ||
        header.classList.contains('header--fixed') ||
        header.classList.contains('header--sticky')
      ) {
        top = Math.max(top, hRect.bottom);
      }
    }

    if (top <= 0) {
      const rootStyles = getComputedStyle(document.documentElement);
      const headerPx = parseFloat(rootStyles.getPropertyValue('--header-height')) || 70;
      const announcementPx =
        parseFloat(rootStyles.getPropertyValue('--announcement-bar-height')) || 0;
      top = headerPx + announcementPx;
    }

    wrapper.style.setProperty('--sticky-atc-top', top + 'px');
  }

  function forceRechargeRowLayout(widget) {
    if (!widget || !widget.shadowRoot || !isInsideSticky(widget)) return false;

    const root = widget.shadowRoot;
    const wrap =
      root.querySelector('.rc-content-wrap, [part~="rc-content-wrap"]') ||
      root.querySelector('[class*="content-wrap"]');

    if (!wrap) return false;

    const mobile = isMobileSticky();

    wrap.style.setProperty('display', 'flex', 'important');
    wrap.style.setProperty('flex-direction', mobile ? 'column' : 'row', 'important');
    wrap.style.setProperty('flex-wrap', 'nowrap', 'important');
    wrap.style.setProperty('align-items', 'stretch', 'important');
    wrap.style.setProperty('gap', '8px', 'important');
    wrap.style.setProperty('width', mobile ? '100%' : 'max-content', 'important');

    const options = root.querySelectorAll(
      '.rc-purchase-option__onetime, .rc-purchase-option__subscription, [part~="rc-purchase-option__onetime"], [part~="rc-purchase-option__subscription"]'
    );

    options.forEach(function (option) {
      const isOneTime =
        option.classList.contains('rc-purchase-option__onetime') ||
        (option.getAttribute('part') || '').indexOf('rc-purchase-option__onetime') !== -1;

      option.style.setProperty('display', 'flex', 'important');
      option.style.setProperty('flex-direction', 'column', 'important');
      option.style.setProperty('flex', '0 0 auto', 'important');
      option.style.setProperty('align-self', 'stretch', 'important');
      option.style.setProperty('align-items', 'stretch', 'important');
      option.style.setProperty('min-width', mobile ? '0' : 'max-content', 'important');
      option.style.setProperty('width', mobile ? '100%' : 'auto', 'important');

      if (isOneTime) {
        option.style.setProperty('height', '56px', 'important');
        option.style.setProperty('min-height', '56px', 'important');
        option.style.setProperty('max-height', '56px', 'important');
      } else {
        option.style.setProperty('height', 'auto', 'important');
        option.style.setProperty('min-height', '56px', 'important');
        option.style.setProperty('max-height', 'none', 'important');
      }
    });

    const purchaseOptions = root.querySelectorAll(
      '.rc-purchase-option, [part~="rc-purchase-option"]'
    );
    purchaseOptions.forEach(function (option) {
      const isOneTime =
        option.classList.contains('rc-purchase-option__onetime') ||
        (option.getAttribute('part') || '').indexOf('rc-purchase-option__onetime') !== -1;

      option.style.setProperty('display', 'flex', 'important');
      option.style.setProperty('flex-direction', 'column', 'important');
      option.style.setProperty('align-items', 'stretch', 'important');

      if (mobile) {
        option.style.setProperty('width', '100%', 'important');
        option.style.setProperty('min-width', '0', 'important');
      }

      if (isOneTime) {
        option.style.setProperty('height', '56px', 'important');
        option.style.setProperty('min-height', '56px', 'important');
        option.style.setProperty('max-height', '56px', 'important');
      } else {
        option.style.setProperty('height', 'auto', 'important');
        option.style.setProperty('min-height', '56px', 'important');
        option.style.setProperty('max-height', 'none', 'important');
      }
    });

    if (mobile) {
      options.forEach(function (option) {
        option.style.setProperty('margin-bottom', '0', 'important');
      });
      purchaseOptions.forEach(function (option) {
        option.style.setProperty('margin-bottom', '0', 'important');
      });
    }

    const labels = root.querySelectorAll(
      '.rc-purchase-option__label, [part~="rc-purchase-option__label"]'
    );
    labels.forEach(function (label) {
      label.style.setProperty('display', 'flex', 'important');
      label.style.setProperty('flex-direction', 'row', 'important');
      label.style.setProperty('align-items', 'center', 'important');
      label.style.setProperty('justify-content', 'normal', 'important');
    });

    return options.length >= 2;
  }

  function clearRechargeRowLayout(widget) {
    if (!widget || !widget.shadowRoot) return;

    const nodes = widget.shadowRoot.querySelectorAll(
      '.rc-content-wrap, [part~="rc-content-wrap"], .rc-purchase-option, .rc-purchase-option__onetime, .rc-purchase-option__subscription, .rc-purchase-option__label, [part~="rc-purchase-option"], [part~="rc-purchase-option__onetime"], [part~="rc-purchase-option__subscription"], [part~="rc-purchase-option__label"]'
    );

    nodes.forEach(function (node) {
      [
        'display',
        'flex-direction',
        'flex-wrap',
        'align-items',
        'justify-content',
        'gap',
        'width',
        'height',
        'min-height',
        'max-height',
        'flex',
        'align-self',
        'min-width',
        'margin-bottom'
      ].forEach(function (prop) {
        node.style.removeProperty(prop);
      });
    });
  }

  function applyRechargeStickyStyles(widget) {
    if (!widget || !isInsideSticky(widget) || !widget.shadowRoot) return;

    let style = widget.shadowRoot.getElementById(CONFIG.shadowStyleId);
    if (!style) {
      style = document.createElement('style');
      style.id = CONFIG.shadowStyleId;
      widget.shadowRoot.appendChild(style);
    }
    style.textContent = STICKY_WIDGET_CSS;
    forceRechargeRowLayout(widget);
  }

  function clearRechargeStickyStyles(widget) {
    if (!widget) return;
    clearRechargeRowLayout(widget);
    if (!widget.shadowRoot) return;
    const style = widget.shadowRoot.getElementById(CONFIG.shadowStyleId);
    if (style) style.remove();
  }

  function getWidgetRoot(widget) {
    return widget && widget.shadowRoot ? widget.shadowRoot : null;
  }

  function getSellingPlanInput() {
    return (
      document.querySelector(
        'form.product-form input[name="selling_plan"], form.product-form select[name="selling_plan"], .product-info__pricing input[name="selling_plan"], .product-detail input[name="selling_plan"], input[name="selling_plan"], select[name="selling_plan"]'
      ) || null
    );
  }

  function getPurchaseRadios(widget) {
    const root = getWidgetRoot(widget);
    if (!root) return { subscription: null, onetime: null };

    return {
      subscription: root.querySelector(
        'input[name="purchaseOption"][value="subscription"], input[type="radio"][value="subscription"]'
      ),
      onetime: root.querySelector(
        'input[name="purchaseOption"][value="onetime"], input[type="radio"][value="onetime"]'
      )
    };
  }

  function getSelectedPlan(widget) {
    const radios = getPurchaseRadios(widget);
    if (radios.subscription && radios.subscription.checked) return 'subscription';
    if (radios.onetime && radios.onetime.checked) return 'onetime';

    // Fallback: Recharge marks the selected card with rc-selected / __selected
    const root = getWidgetRoot(widget);
    if (root) {
      const selectedSub = root.querySelector(
        '.rc-purchase-option__subscription[rc-selected], [part~="rc-purchase-option__subscription"][part~="rc-purchase-option__selected"]'
      );
      if (selectedSub) return 'subscription';
      const selectedOne = root.querySelector(
        '.rc-purchase-option__onetime[rc-selected], [part~="rc-purchase-option__onetime"][part~="rc-purchase-option__selected"]'
      );
      if (selectedOne) return 'onetime';
    }

    return radios.subscription ? 'subscription' : 'onetime';
  }

  // Mirror a real user click on the Recharge option label so the widget
  // updates the form's selling_plan input (required by theme ATC).
  function setSelectedPlan(widget, value) {
    const root = getWidgetRoot(widget);
    if (!root) return false;

    const radios = getPurchaseRadios(widget);
    const radio = value === 'onetime' ? radios.onetime : radios.subscription;
    if (radio && radio.checked) return true;

    const option = findOptionEl(widget, value);
    const label =
      (option &&
        option.querySelector(
          'label, .rc-purchase-option__label, [part~="rc-purchase-option__label"]'
        )) ||
      null;

    if (label) {
      label.click();
    } else if (radio) {
      radio.click();
    } else {
      return false;
    }

    return getSelectedPlan(widget) === value;
  }

  function selectionMatchesNative(widget, value) {
    if (!widget) return false;
    if (getSelectedPlan(widget) !== value) return false;

    const selling = getSellingPlanInput();
    if (!selling) return true; // widget may still be mounting

    if (value === 'subscription') {
      return !!(selling.value && String(selling.value).trim());
    }
    // One-time must clear selling_plan so ATC does not send a plan id
    return !selling.value || !String(selling.value).trim();
  }

  function extractDollarAmounts(text) {
    return (text || '').match(/\$\d[\d,]*(?:\.\d{2})?/g) || [];
  }

  // Prefer Recharge price parts used by the PDP native price script.
  function findPriceText(optionEl) {
    if (!optionEl) return '';

    const discounted = optionEl.querySelector(
      '[part~="rc-purchase-option__discounted-price"], .rc-purchase-option__discounted-price'
    );
    if (discounted) {
      const salePrices = extractDollarAmounts(discounted.textContent);
      if (salePrices.length) return salePrices[salePrices.length - 1];
    }

    const normal = optionEl.querySelector(
      '[part~="rc-purchase-option__price"], .rc-purchase-option__price'
    );
    if (normal) {
      const prices = extractDollarAmounts(normal.textContent);
      if (prices.length) return prices[prices.length - 1];
    }

    const priceNode = optionEl.querySelector(
      '.rc-purchase-option__prices, [part~="rc-purchase-option__prices"], .rc-price, [part~="rc-price"]'
    );
    if (priceNode) {
      const prices = extractDollarAmounts(priceNode.textContent);
      if (prices.length) return prices[prices.length - 1];
    }

    const allPrices = extractDollarAmounts(optionEl.textContent);
    if (!allPrices.length) return '';
    return allPrices[allPrices.length - 1];
  }

  function findOptionEl(widget, plan) {
    const root = getWidgetRoot(widget);
    if (!root) return null;

    if (plan === 'subscription') {
      return (
        root.querySelector(
          '.rc-purchase-option__subscription, [part~="rc-purchase-option__subscription"]'
        ) || null
      );
    }

    return (
      root.querySelector(
        '.rc-purchase-option__onetime, [part~="rc-purchase-option__onetime"]'
      ) || null
    );
  }

  function getPlanMeta(widget, plan) {
    const price = findPriceText(findOptionEl(widget, plan));
    if (plan === 'subscription') {
      return { value: 'subscription', prefix: 'Subscribe', price: price };
    }
    return { value: 'onetime', prefix: 'One Time', price: price };
  }

  function formatPlanHtml(meta) {
    if (!meta) return '';
    const priceHtml = meta.price
      ? ':&nbsp;<span class="sticky-atc__plan-price">' + meta.price + '</span>'
      : '';
    return (
      '<span class="sticky-atc__plan-text">' +
      '<span class="sticky-atc__plan-prefix">' +
      meta.prefix +
      '</span>' +
      priceHtml +
      '</span>'
    );
  }

  function ensureWrapper() {
    let wrapper = document.getElementById(CONFIG.wrapperId);
    if (
      wrapper &&
      (!wrapper.querySelector('.sticky-atc__dropdown') ||
        !wrapper.querySelector('.sticky-atc__widget'))
    ) {
      wrapper.remove();
      wrapper = null;
    }

    if (wrapper) {
      const titleEl = wrapper.querySelector('.sticky-atc__title');
      if (titleEl && !titleEl.textContent.trim()) {
        titleEl.textContent = getProductTitle();
      }
      return wrapper;
    }

    wrapper = document.createElement('div');
    wrapper.id = CONFIG.wrapperId;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Sticky add to cart');
    wrapper.innerHTML =
      '<div class="sticky-atc__inner">' +
      '<p class="product-info__title sticky-atc__title"></p>' +
      '<div class="sticky-atc__actions">' +
      '<div class="sticky-atc__widget"></div>' +
      '<div class="sticky-atc__plan" hidden>' +
      '<div class="sticky-atc__dropdown">' +
      '<button type="button" class="sticky-atc__plan-btn" id="sticky-atc-plan-btn" ' +
      'role="combobox" aria-haspopup="listbox" aria-expanded="false" ' +
      'aria-controls="sticky-atc-plan-list" aria-label="Purchase option">' +
      '<span class="sticky-atc__plan-current"></span>' +
      CHEVRON_SVG +
      '</button>' +
      '<ul class="sticky-atc__plan-list" id="sticky-atc-plan-list" role="listbox" ' +
      'aria-label="Purchase option" hidden></ul>' +
      '</div>' +
      '</div>' +
      '<div class="sticky-atc__button"></div>' +
      '</div>' +
      '</div>';

    wrapper.querySelector('.sticky-atc__title').textContent = getProductTitle();
    document.body.appendChild(wrapper);
    return wrapper;
  }

  function waitForButton() {
    return new Promise(function (resolve) {
      const started = Date.now();

      function tick() {
        const button = document.querySelector(CONFIG.buttonSelector);
        if (button) {
          resolve(button);
          return;
        }
        if (Date.now() - started >= CONFIG.waitTimeoutMs) {
          resolve(null);
          return;
        }
        setTimeout(tick, CONFIG.waitIntervalMs);
      }

      tick();
    });
  }

  function init(button) {
    if (!button || button.dataset.stickyAtcBound === 'true') return;
    button.dataset.stickyAtcBound = 'true';

    const widget = document.querySelector(CONFIG.widgetSelector);
    const observeTarget =
      document.querySelector(CONFIG.observeSelector) || button.parentElement;

    if (!observeTarget) return;

    clearRechargeStickyStyles(widget);

    const widgetPlaceholder = widget
      ? createPlaceholder('sticky-atc-widget-placeholder')
      : null;
    const buttonPlaceholder = createPlaceholder('sticky-atc-button-placeholder');

    if (widget && widget.parentNode) {
      widget.parentNode.insertBefore(widgetPlaceholder, widget);
      clearPlaceholder(widgetPlaceholder);
    }
    button.parentNode.insertBefore(buttonPlaceholder, button);
    clearPlaceholder(buttonPlaceholder);

    const widgetOriginalParent = widget ? widget.parentNode : null;

    const wrapper = ensureWrapper();
    const stickyWidgetSlot = wrapper.querySelector('.sticky-atc__widget');
    const stickyButtonSlot = wrapper.querySelector('.sticky-atc__button');
    const titleEl = wrapper.querySelector('.sticky-atc__title');
    const planWrap = wrapper.querySelector('.sticky-atc__plan');
    const dropdown = wrapper.querySelector('.sticky-atc__dropdown');
    const planBtn = wrapper.querySelector('.sticky-atc__plan-btn');
    const planCurrent = wrapper.querySelector('.sticky-atc__plan-current');
    const planList = wrapper.querySelector('.sticky-atc__plan-list');

    let isSticky = false;
    let stickyMode = null; // 'mobile' | 'desktop'
    let stickyGeneration = 0;
    let ticking = false;
    let syncingFromSelect = false;
    let isOpen = false;
    let rechargeObserver = null;
    let availablePlans = [];
    let proxyButton = null;
    let buttonObserver = null;

    // Keep the real ATC button inside the product form so theme JS can still
    // read input[name="selling_plan"]. Sticky shows a visual proxy that clicks it.
    function syncProxyButton() {
      if (!proxyButton) return;
      proxyButton.innerHTML = button.innerHTML;
      proxyButton.disabled = !!button.disabled;
      if (button.className) {
        proxyButton.className =
          button.className.replace(/\bsticky-atc__source-hidden\b/g, '').trim() +
          ' sticky-atc__proxy-btn';
      }
    }

    function ensureProxyButton() {
      if (proxyButton) {
        syncProxyButton();
        return proxyButton;
      }

      proxyButton = button.cloneNode(true);
      proxyButton.removeAttribute('data-add-to-cart');
      proxyButton.removeAttribute('data-sticky-atc-bound');
      proxyButton.removeAttribute('id');
      proxyButton.classList.add('sticky-atc__proxy-btn');
      proxyButton.setAttribute('type', 'button');
      proxyButton.setAttribute('aria-label', button.getAttribute('aria-label') || 'Add to cart');

      proxyButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (button.disabled) return;
        button.click();
      });

      if (!buttonObserver) {
        buttonObserver = new MutationObserver(syncProxyButton);
        buttonObserver.observe(button, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'class']
        });
      }

      syncProxyButton();
      return proxyButton;
    }

    function moveButtonToSticky() {
      setPlaceholderSize(buttonPlaceholder, button);
      button.classList.add('sticky-atc__source-hidden');
      stickyButtonSlot.appendChild(ensureProxyButton());
    }

    function moveButtonBack() {
      if (proxyButton && proxyButton.parentNode) {
        proxyButton.parentNode.removeChild(proxyButton);
      }
      button.classList.remove('sticky-atc__source-hidden');
      clearPlaceholder(buttonPlaceholder);
    }

    function closeDropdown() {
      if (!isOpen) return;
      isOpen = false;
      if (planBtn) planBtn.setAttribute('aria-expanded', 'false');
      if (dropdown) dropdown.classList.remove('is-open');
      if (planList) planList.hidden = true;
    }

    function openDropdown() {
      if (isOpen || !availablePlans.length) return;
      isOpen = true;
      if (planBtn) planBtn.setAttribute('aria-expanded', 'true');
      if (dropdown) dropdown.classList.add('is-open');
      if (planList) planList.hidden = false;
    }

    function toggleDropdown() {
      if (isOpen) closeDropdown();
      else openDropdown();
    }

    function renderDropdown(widgetEl) {
      if (!planWrap || !planBtn || !planCurrent || !planList || !widgetEl) {
        if (planWrap) planWrap.hidden = true;
        return false;
      }

      const radios = getPurchaseRadios(widgetEl);
      availablePlans = [];
      if (radios.subscription) availablePlans.push(getPlanMeta(widgetEl, 'subscription'));
      if (radios.onetime) availablePlans.push(getPlanMeta(widgetEl, 'onetime'));

      if (!availablePlans.length) {
        planWrap.hidden = true;
        closeDropdown();
        return false;
      }

      // Only show custom dropdown while sticky + mobile mode
      planWrap.hidden = !(isSticky && stickyMode === 'mobile');

      const selected = getSelectedPlan(widgetEl);
      const current =
        availablePlans.find(function (p) {
          return p.value === selected;
        }) || availablePlans[0];

      planCurrent.innerHTML = formatPlanHtml(current);

      const alternates = availablePlans.filter(function (p) {
        return p.value !== current.value;
      });

      planList.innerHTML = alternates
        .map(function (opt) {
          return (
            '<li class="sticky-atc__plan-option" role="option" tabindex="0" ' +
            'data-value="' +
            opt.value +
            '" aria-selected="false">' +
            formatPlanHtml(opt) +
            '</li>'
          );
        })
        .join('');

      return true;
    }

    function choosePlan(value) {
      if (!widget || !value) return;
      syncingFromSelect = true;
      setSelectedPlan(widget, value);
      closeDropdown();

      // Recharge updates selling_plan asynchronously after the label click.
      // Retry briefly so sticky selection matches the native widget + ATC.
      var attempts = 0;
      function verify() {
        attempts += 1;
        if (selectionMatchesNative(widget, value) || attempts >= 8) {
          syncingFromSelect = false;
          renderDropdown(widget);
          return;
        }
        if (attempts === 3 || attempts === 6) {
          setSelectedPlan(widget, value);
        }
        window.setTimeout(verify, 75);
      }
      window.setTimeout(verify, 50);
    }

    function syncSelectFromWidget() {
      if (syncingFromSelect) return;
      renderDropdown(widget);
    }

    if (planBtn) {
      planBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!(isSticky && stickyMode === 'mobile')) return;
        toggleDropdown();
      });
    }

    if (planList) {
      planList.addEventListener('click', function (e) {
        const option = e.target.closest('.sticky-atc__plan-option');
        if (!option) return;
        e.preventDefault();
        choosePlan(option.getAttribute('data-value'));
      });

      planList.addEventListener('keydown', function (e) {
        const option = e.target.closest('.sticky-atc__plan-option');
        if (!option) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          choosePlan(option.getAttribute('data-value'));
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      if (dropdown && dropdown.contains(e.target)) return;
      closeDropdown();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    if (widget) {
      let attempts = 0;
      const waitForWidget = window.setInterval(function () {
        attempts += 1;
        const ready = renderDropdown(widget);
        if (ready || attempts >= 40) {
          window.clearInterval(waitForWidget);
          if (widget.shadowRoot && !rechargeObserver) {
            rechargeObserver = new MutationObserver(function () {
              if (isSticky && stickyMode === 'mobile') syncSelectFromWidget();
            });
            rechargeObserver.observe(widget.shadowRoot, {
              subtree: true,
              childList: true,
              attributes: true,
              characterData: true
            });
          }
        }
      }, 250);
    } else if (planWrap) {
      planWrap.hidden = true;
    }

    function getStickyTopOffset() {
      const fromStyle = parseFloat(wrapper.style.getPropertyValue('--sticky-atc-top'));
      if (!isNaN(fromStyle) && fromStyle > 0) return fromStyle;

      const fromCss = parseFloat(
        getComputedStyle(wrapper).getPropertyValue('--sticky-atc-top')
      );
      return !isNaN(fromCss) && fromCss > 0 ? fromCss : 0;
    }

    function getTriggerElement() {
      if (isSticky && buttonPlaceholder && buttonPlaceholder.classList.contains('is-active')) {
        return buttonPlaceholder;
      }
      return button;
    }

    function shouldShowSticky() {
      const rect = getTriggerElement().getBoundingClientRect();
      return rect.bottom <= getStickyTopOffset();
    }

    function scheduleRowLayout(generation, attemptsLeft) {
      if (generation !== stickyGeneration || !isSticky || stickyMode !== 'desktop') return;
      if (!widget || !isInsideSticky(widget)) return;

      applyRechargeStickyStyles(widget);
      if (forceRechargeRowLayout(widget) || attemptsLeft <= 0) return;

      setTimeout(function () {
        scheduleRowLayout(generation, attemptsLeft - 1);
      }, 150);
    }

    function moveWidgetToSticky() {
      if (!widget || !widgetPlaceholder || !stickyWidgetSlot) return;
      if (isInsideSticky(widget)) {
        applyRechargeStickyStyles(widget);
        return;
      }
      setPlaceholderSize(widgetPlaceholder, widget);
      stickyWidgetSlot.appendChild(widget);
      applyRechargeStickyStyles(widget);
    }

    function moveWidgetBack() {
      if (!widget || !widgetOriginalParent || !widgetPlaceholder) return;
      clearRechargeStickyStyles(widget);
      if (isInsideSticky(widget)) {
        widgetOriginalParent.insertBefore(widget, widgetPlaceholder.nextSibling);
      }
      clearPlaceholder(widgetPlaceholder);
      clearRechargeStickyStyles(widget);
    }

    function applyStickyMode(mode) {
      const generation = ++stickyGeneration;
      stickyMode = mode;
      wrapper.classList.toggle('sticky-atc--mobile', mode === 'mobile');
      wrapper.classList.toggle('sticky-atc--desktop', mode === 'desktop');
      wrapper.classList.toggle('sticky-atc--simple', mode === 'simple');

      if (mode === 'simple') {
        closeDropdown();
        moveWidgetBack();
        if (planWrap) planWrap.hidden = true;
        return;
      }

      if (mode === 'mobile') {
        closeDropdown();
        moveWidgetBack();
        if (planWrap) planWrap.hidden = !widget;
        syncSelectFromWidget();
      } else {
        closeDropdown();
        if (planWrap) planWrap.hidden = true;
        moveWidgetToSticky();
        requestAnimationFrame(function () {
          if (generation !== stickyGeneration || !isSticky) return;
          scheduleRowLayout(generation, 12);
        });
      }
    }

    function getDesiredMode() {
      return isMobileSticky() ? 'simple' : 'desktop';
    }

    function moveToSticky() {
      const desiredMode = getDesiredMode();

      if (isSticky) {
        if (stickyMode !== desiredMode) {
          applyStickyMode(desiredMode);
        } else if (desiredMode === 'desktop' && widget) {
          applyRechargeStickyStyles(widget);
        } else if (desiredMode === 'mobile') {
          syncSelectFromWidget();
        }
        return;
      }

      if (titleEl) titleEl.textContent = getProductTitle();
      updateStickyTop(wrapper);

      moveButtonToSticky();

      wrapper.classList.add('is-visible');
      document.documentElement.classList.add('sticky-atc-active');
      isSticky = true;

      applyStickyMode(desiredMode);
    }

    function moveBack() {
      if (!isSticky) return;

      stickyGeneration += 1;
      isSticky = false;
      stickyMode = null;
      closeDropdown();

      moveWidgetBack();
      moveButtonBack();

      if (planWrap) planWrap.hidden = true;
      wrapper.classList.remove(
        'is-visible',
        'sticky-atc--mobile',
        'sticky-atc--desktop',
        'sticky-atc--simple'
      );
      document.documentElement.classList.remove('sticky-atc-active');
    }

    function updateStickyVisibility() {
      updateStickyTop(wrapper);

      if (shouldShowSticky()) {
        moveToSticky();
      } else {
        moveBack();
      }
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (isOpen) closeDropdown();
        updateStickyVisibility();
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    updateStickyVisibility();
  }

  function boot() {
    waitForButton().then(function (button) {
      if (!button) return;
      init(button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
